module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inp-popup tw-absolute z-1001 tw-shadow-lg tw-rounded tw-bg-white tw-text-black tw-shadow-md tw-border tw-border-gray-300 tw-shadow-gray-700 tw-cursor-default",
    class: [{
        'tw-animate-fade-in': _vm.isVisible
      },
      {
        'tw-animate-fade-out': !_vm.isVisible
      },
      {
        'tw-collapse tw-invisible': !_vm.isVisibleDelay
      },
      {
        'tw-visible': _vm.isVisibleDelay
      }
    ],
    style: ('top: ' + this.x + 'px;right: ' + this.y + 'px;width: ' + this.width + 'px' + 'px;max-width: ' + this.maxWidth + 'px'),
    on: {
      "click": function($event) {
        _vm.click($event)
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48363a34"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/PanelPopup/PanelPopup.vue.html
// module id = ZU+p
// module chunks = 2